
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class MessageBar extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    public readonly value!: boolean;

    @Prop({ type: String, required: false, default: '' })
    public readonly message!: string;

    @Prop({ type: Boolean, required: false, default: false })
    public readonly error!: boolean;

    @Prop({ type: Number, required: false, default: 0 })
    public readonly duration!: number;

    @Prop({ type: String, required: false, default: null })
    public readonly dismissLabel!: string | null;

    private timerReference: any = null;

    @Watch('value', { immediate: true })
    public onValueChanged(show: boolean): void {
        if (show) {
            this.$nextTick(() => {
                if (this.duration > 0) {
                    if (this.timerReference !== null) {
                        clearTimeout(this.timerReference);
                        this.timerReference = null;
                    }
                    this.timerReference = setTimeout(() => {
                        this.timerReference = null;
                        this.onDismiss();
                    }, this.duration);
                }
            });
        }
    }

    public onDismiss(): void {
        this.$emit('input', false);
    }
}
